import React from 'react';
import { motion } from 'framer-motion';
import Button from '../Components/ui/Button';
import FreeConsultationCTA from '../Components/FreeConsultationCTA';
import Booking from '../Components/Booking/Booking';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (custom = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.2,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardItem = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 },
  },
};

const services = {
  'stress-pain': {
    title: 'Stress/Pain Relief',
    treatments: [
      {
        name: 'Deep Tissue Massage',
        description:
          'Targets chronic muscle tension and knots using firm pressure and slow strokes.',
        price: '₦30,000',
        duration: '60 mins',
      },
      {
        name: 'Swedish Massage',
        description:
          'Classic relaxation massage using gentle to medium pressure with flowing strokes.',
        price: '₦25,000',
        duration: '60 mins',
      },
      {
        name: 'Hot Stone Therapy',
        description:
          'Combines heated stones with massage for deep relaxation and muscle relief.',
        price: '₦30,000',
        duration: '90 mins',
      },
      {
        name: 'Back/Neck Massage',
        description:
          'Focused treatment for relieving tension and discomfort in the back and neck areas.',
        price: '₦20,000',
        duration: '30 mins',
      },
      {
        name: 'Ashiatsu Massage',
        description:
          "Deep barefoot massage technique that applies pressure using the therapist's feet.",
        price: '₦20,000',
        duration: '60 mins',
      },
    ],
  },
  sensual: {
    title: 'Sensual Massage',
    treatments: [
      {
        name: 'Nuru',
        description:
          'An intimate massage using a special gel for full-body relaxation and connection.',
        price: '₦100,000',
        duration: '90 mins',
      },
      {
        name: 'Lingam Massage',
        description: 'A sensual therapy focused on energy release and relaxation.',
        price: '₦50,000',
        duration: '60 mins',
      },
      {
        name: 'Soapy/Shower Massage',
        description:
          'A unique experience combining water and soothing foam for ultimate relaxation.',
        price: '₦70,000',
        duration: '60 mins',
      },
      {
        name: 'Sleepover Ecstasy Massage',
        description:
          'An extended overnight massage experience to deeply rejuvenate and unwind.',
        price: '₦200,000',
        duration: 'Overnight',
      },
      {
        name: 'Chair Sensual Massage',
        description:
          'A quick yet effective sensual massage performed while seated on a chair.',
        price: '₦40,000',
        duration: '30 mins',
      },
      {
        name: 'Tantric/Erotic Massage',
        description:
          'A deeply relaxing massage aimed at awakening and channeling energy.',
        price: '₦120,000',
        duration: '90 mins',
      },
    ],
  },
};

const MassageTherapy = () => {
  return (
    <div className="min-h-screen">
      {/* Header section */}
      <div className="relative h-[300px] w-full">
        <div className="absolute inset-0">
          <img
            src={'/static/images/pagesBg/massage.jpg'}
            alt="Spa Interior"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        <div className="relative h-full flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl text-white text-center font-semibold">
            Massage <br />
            Therapy
          </h1>
        </div>
      </div>

      {/* Services section */}
      <div className="max-w-6xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold text-center text-dim-light mb-12 font-lato">
          Massage Therapy Services
        </h2>

        {Object.entries(services).map(([categoryId, category], index) => (
          <motion.div
            key={categoryId}
            className="mb-16"
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={index}
          >
            <div className="flex justify-between items-center mb-8 border-b-2 border-dim-dark pb-4">
              <h3 className="text-2xl font-semibold text-dim">{category.title}</h3>
            </div>

            <motion.div
              className="flex overflow-x-auto md:overflow-visible gap-4 md:flex-wrap px-1 -mx-2 md:mx-0"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              style={{
                scrollSnapType: 'x mandatory',
              }}
            >
              {category.treatments.map((treatment, i) => (
                <motion.div
                  key={i}
                  className="flex-none snap-start md:snap-none w-[85%] sm:w-[65%] md:w-[31%] bg-white rounded-xl shadow-md border border-gray-200 p-6"
                  variants={cardItem}
                >
                  <h4 className="text-xl font-semibold text-primary-dark mb-2">
                    {treatment.name}
                  </h4>
                  <p className="text-gray-600 mb-3">{treatment.description}</p>
                  <p className="font-medium mb-1">Price: {treatment.price}</p>
                  <p className="font-medium mb-4">Duration: {treatment.duration}</p>
                  <Button to="../booking" variant="accent">
                    Book Now
                  </Button>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        ))}

        <Booking />

        <FreeConsultationCTA message="I'm interested in a free massage consultation. Can you help me?" />
      </div>
    </div>
  );
};

export default MassageTherapy;